// Dynamic-form schemas for the Move Sublot Inventory feature.
// SearchLayout drives the Find (List) search panel; HeaderLayout drives the
// header form on the Move screen. Same schema shape as the reference
// chargeCodeDataEntry/Layout.js (field types: text, select, lookup, date,
// number, textarea).

import { ACDepartmentLayout } from '../../../common/lookups/Layouts/ACLayouts';
import { CAJobLayout } from '../../../common/lookups/Layouts/CALayouts';
import { FAFundLayout } from '../../../common/lookups/Layouts/FALayouts';

export const SearchLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "customerCode",
                "tableName": "",
                "label": "Customer",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "itemCode",
                "tableName": "",
                "label": "Item",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "fields": [
            {
                "name": "lotCode",
                "tableName": "",
                "label": "Lot",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "fields": [
            {
                "name": "sublotCode",
                "tableName": "",
                "label": "Sublot",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
];

// One field per group so FormField lays them out across columns (each group is a
// flex column), matching the search-panel layout — instead of a single stacked column.
// tableName is WMTRANSACTIONHEADER on every field so the dynamic form can resolve the
// column max length (Localization.maxLength) and the localized label; an empty tableName
// leaves text fields unbounded and forces the hardcoded English caption.
export const HeaderLayout = [
    {
        "groupId": 0,
        "fields": [
            {
                // Read-only display of the customer's WM Adjustment Profile (legacy showed this in the
                // panel). Not a WMTRANSACTIONHEADER column, so no tableName; populated from the customer.
                "name": "PROFILE",
                "tableName": "",
                "label": "Profile",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": true,
            }
        ]
    },
    {
        "groupId": 1,
        "fields": [
            {
                "name": "TRANSACTIONNUMBER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Transaction Number",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "SHIPPERBOLNUMBER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Shipper BOL Number",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "fields": [
            {
                "name": "REFERENCE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Reference",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "fields": [
            {
                "name": "TRANSACTIONGROUP",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Transaction Group",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 5,
        "fields": [
            {
                "name": "PLANREFERENCE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Plan Reference",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 6,
        "fields": [
            {
                "name": "EQUIPMENTINTERCHANGEREPORT",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Equipment Interchange Report",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 7,
        "fields": [
            {
                "name": "TRANSACTIONDATE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Transaction Date",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 8,
        "fields": [
            {
                "name": "ACTUALRECEIVEDSHIPPEDDATE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Actual Rec/Ship Date",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 9,
        "fields": [
            {
                "name": "DELIVERYPICKUPDEPARTDATETIME",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Delivery/Pickup Depart Date",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 10,
        "fields": [
            {
                "name": "R_GLDEPARTMENT",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Department",
                "type": "lookup",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
                "layout": ACDepartmentLayout
            }
        ]
    },
    {
        "groupId": 11,
        "fields": [
            {
                "name": "R_CAJOB",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Job",
                "type": "lookup",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
                "layout": CAJobLayout
            }
        ]
    },
    {
        "groupId": 12,
        "fields": [
            {
                "name": "R_GLFUND",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Fund",
                "type": "lookup",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
                "layout": FAFundLayout
            }
        ]
    },
    {
        "groupId": 13,
        "fields": [
            {
                "name": "COMMENT",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
];
